import { render, staticRenderFns } from "./dclshgz12026.vue?vue&type=template&id=64ce59c0&scoped=true"
import script from "./dclshgz12026.vue?vue&type=script&lang=js"
export * from "./dclshgz12026.vue?vue&type=script&lang=js"
import style0 from "./dclshgz12026.vue?vue&type=style&index=0&id=64ce59c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce59c0",
  null
  
)

export default component.exports